export function getWindowDomain(host) {
  const hostName = host || (typeof window !== 'undefined' ? window.location.hostname : null);
  return hostName ? hostName.split('.').slice(-2).join('.') : null;
}

export function getEnvironment(host) {
  if (typeof window === 'undefined' && !host) {
    return null;
  }

  const hostName = host || window.location.hostname;

  const env = hostName.split('.')[0].split('-')[0];
  return (env === 'www' || env === 'www2' || env === 'ppi2pass') ? 'production' : env;
}

export function getCurrentURL() {
  return typeof window !== 'undefined' ? window.location.href : null;
}

export function getCartDomain(host) {
  if (typeof window === 'undefined' && !host) {
    return null;
  }

  const windowDomain = getWindowDomain(host);
  const env = getEnvironment(host);
  let cartPrefix = 'cart';

  if (env !== 'production') {
    cartPrefix = `${env}-cart`;
  }

  return env === 'local' ? `${cartPrefix}.${windowDomain}:3000` : `${cartPrefix}.${windowDomain}`;
}
